// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2WwYb","fileBtn":"File_fileBtn__3NgoF","closeBtn":"File_closeBtn__180sN","fileSelected":"File_fileSelected__2jtN1","disabled":"File_disabled__9MvpI"};